// Basiert auf https://gitlab.pooliestudios.com/koeln-marathon/app/app-dev

import {Runner} from '../models/runner';

declare global {
    interface Window {
        config?: {
            paths?: Array<never>,
            themePath?: string,
            googleMapsApiKey?: string,
            environment?: string,
            language?: string,
        };
    }
}

export default class RunnerIconProvider {
    static async getIcon(runner: Runner): Promise<google.maps.Icon> {
        let runnerIconUrl = `${window.config.themePath}/assets/images/marker/runner.png`;

        if (runner.profilePictureUrl) {
            runnerIconUrl = await RunnerIconProvider.createPersonalizedImage(runner);
        }

        return RunnerIconProvider.createIconWithUrl(runnerIconUrl);
    }

    static createPersonalizedImage(runner: Runner): Promise<string> {
        return new Promise((resolve) => {
            const canvas: HTMLCanvasElement = document.createElement('canvas');
            const blankMarkerImage: HTMLImageElement = new Image();

            blankMarkerImage.src = `${window.config.themePath}/assets/images/marker/runner-blank-red.png`;

            blankMarkerImage.onload = () => {
                const {
                    width,
                    height,
                } = blankMarkerImage;
                canvas.width = width;
                canvas.height = height;

                const context: CanvasRenderingContext2D & {letterSpacing?: string} = canvas.getContext('2d');
                context.drawImage(blankMarkerImage, 0, 0);

                if (runner.profilePictureUrl) {
                    const profilePicture: HTMLImageElement = new Image();
                    profilePicture.crossOrigin = 'anonymous';
                    profilePicture.src = runner.profilePictureUrl;
                    profilePicture.onload = () => {
                        context.save();
                        context.beginPath();
                        context.arc(width / 2, 66, 26, 0, Math.PI * 2, true);
                        context.closePath();
                        context.clip();

                        context.drawImage(profilePicture, width / 2 - 26, 40, 52, 52);
                        context.closePath();
                        context.restore();

                        resolve(canvas.toDataURL('image/png'));
                    };
                } else {
                    context.textAlign = 'center';
                    context.textBaseline = 'middle';
                    context.fillStyle = '#2B3946';
                    context.letterSpacing = '1px';
                    context.font = 'bold 24px Bison';

                    context.fillText(runner.getInitials(), width / 2, 68);

                    resolve(canvas.toDataURL('image/png'));
                }
            };
        });
    }

    static createIconWithUrl(url: string): google.maps.Icon {
        return {
            url,
            scaledSize: new google.maps.Size(82, 101),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(41, 91),
        };
    }
}
